export enum PageMode {
  New,
  Edit,
  View
}
